import View from './view.js'
import { useDataSubmit, useDataChange, useDataValue } from 'Simple/Data'
import React, { useMemo } from 'react'
import { dateISOToDateAndTime, toTitleCase } from 'Data/format'
import ChangeStatusAction from './ChangeStatusAction/index.js'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index.js'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index.js'
import TysiaText from 'design-system/TysiaText/view.js'

let EVENT_TYPES = /** @type {const} */ ({
  appointment_bookings_state_update: 'Appointment status changing',
  txs_status_update: 'Treatment status changing',
  custom_resource_insert: 'Custom resource created',
  patient_demographics_changed: 'Patient demographics changed',
  contract_signed: 'Contract signed',
  order_status_changed: 'Order status changed',
  document_signed: 'Document signed',
  medical_form_submitted: 'Medical form submitted',
  lead_status_changed: 'Lead created',
  payment_made: 'Payment made',
  payment_method_updated: 'Payment method updated',
})

export default function Logic(props) {
  let events = useDataValue({
    context: 'events',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let tableData = useMemo(
    () => ({
      columns: [
        {
          header: '',
          accessorKey: 'id',
          cell: cell => (
            <TysiaCheckbox
              onChange={value => {
                change(next => {
                  if (value) {
                    next.selected.automations.push(cell.row.original.id)
                  } else {
                    next.selected.automations =
                      next.selected.automations.filter(
                        item => item !== cell.row.original.id
                      )
                  }
                })
              }}
              value={cell.row.original.selected}
              viewPath={props.viewPath}
            >
              {childProps => <TysiaCheckboxInput {...childProps} />}
            </TysiaCheckbox>
          ),
        },
        {
          header: 'Name',
          accessorKey: 'name',
          cell: cell => (
            <TysiaText
              weight="medium"
              viewPath={props.viewPath}
              text={cell.getValue() ?? '-'}
            />
          ),
        },
        {
          header: 'Type',
          accessorKey: 'automation_type',
          cell: cell => toTitleCase(cell.getValue() ?? '-'),
        },
        {
          header: 'Trigger',
          accessorFn: row => `${EVENT_TYPES[row.type]}`,
        },
        {
          header: 'Last Modified at',
          accessorKey: 'updated_at',
          cell: cell => dateISOToDateAndTime(cell.getValue()),
        },
        {
          header: 'Running',
          id: 'status',
          accessorKey: 'status',
          cell: cell => (
            <ChangeStatusAction
              viewPath={`${props.viewPath}/TableX/TableActions`}
              isActive={cell.row.original?.status === 'active'}
              disabled={cell.row.original?.app_id !== null}
              onChange={event => {
                submit({
                  type: 'toggleStatus',
                  status:
                    cell.row.original?.status === 'active'
                      ? 'disabled'
                      : 'active',
                  event_id: cell.row.original?.id,
                  event_type: cell.row.original?.type,
                  data: cell.row.original?.data,
                  organization_id: cell.row.original?.organization_id,
                  automation_type: cell.row.original?.automation_type,
                })
              }}
            />
          ),
        },
      ],
      data: events ?? [],
    }),
    [events]
  )

  return <View viewPath={props.viewPath} tableData={tableData} />
}
